<!-- ACCUEIL -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head
    mdbWavesEffect
    [indicator]="false"
    [routerLink]="PATHS.USER_MY_DASHBOARD.path"
    [routerLinkActiveOptions]="{ exact: true }"
    routerLinkActive="active-link"
  >
    <mdb-icon fas icon="home"></mdb-icon>
    <span jhiTranslate="sidebar.user.dashboard" data-id-cypress="sidebar-user-dashboard">Dashboard</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- BASKET -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head [indicator]="false" mdbWavesEffect [routerLink]="PATHS.ORDER_BASKET.path" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active-link">
    <mdb-icon fas icon="shopping-cart"></mdb-icon>
    <span jhiTranslate="sidebar.user.basket" data-id-cypress="sidebar-user-basket">Basket</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES TRANSPORTS -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head [indicator]="false" mdbWavesEffect [routerLink]="PATHS.USER_MY_TRANSPORTS.path" routerLinkActive="active-link">
    <mdb-icon fas icon="shipping-fast"></mdb-icon>
    <span jhiTranslate="sidebar.user.transport" data-id-cypress="sidebar-user-transports">Transports</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES DEVIS -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head
    mdbWavesEffect
    [indicator]="false"
    [routerLink]="PATHS.USER_MY_QUOTATION.path"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ exact: false }"
  >
    <mdb-icon fas icon="file-circle-question"></mdb-icon>
    <span data-id-cypress="sidebar-user-quotations" jhiTranslate="sidebar.user.quotation">Quotations</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES FACTURES -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.USER_MY_BILLS.path" routerLinkActive="active-link">
    <mdb-icon fas icon="receipt"></mdb-icon>
    <span jhiTranslate="sidebar.user.bill" data-id-cypress="sidebar-user-bills">Bills</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES ADRESSES -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.USER_MY_REGISTERED_ADDRESSES.path" routerLinkActive="active-link">
    <mdb-icon fas icon="book-atlas"></mdb-icon>
    <span jhiTranslate="sidebar.user.address">Adresses</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>
<!-- MES CONTACTS -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.USER_MY_CONTACTS.path" routerLinkActive="active-link">
    <mdb-icon fas icon="address-card"></mdb-icon>
    <span jhiTranslate="sidebar.user.contact">Mes contacts</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>
